/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_All_EquipmentInputs */

const en_us2_swap_all_equipment = /** @type {(inputs: Swap_All_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const pt_br2_swap_all_equipment = /** @type {(inputs: Swap_All_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const es_419_swap_all_equipment = /** @type {(inputs: Swap_All_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const pt_pt2_swap_all_equipment = /** @type {(inputs: Swap_All_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos`)
};

const fr_fr2_swap_all_equipment = /** @type {(inputs: Swap_All_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout`)
};

const de_de2_swap_all_equipment = /** @type {(inputs: Swap_All_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const it_it2_swap_all_equipment = /** @type {(inputs: Swap_All_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Swap_All_EquipmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_all_equipment = /** @type {((inputs?: Swap_All_EquipmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_All_EquipmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_all_equipment(inputs)
	if (locale === "es-419") return es_419_swap_all_equipment(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_all_equipment(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_all_equipment(inputs)
	if (locale === "de-DE") return de_de2_swap_all_equipment(inputs)
	if (locale === "it-IT") return it_it2_swap_all_equipment(inputs)
	return en_us2_swap_all_equipment(inputs)
});
export { swap_all_equipment as "swap.all_equipment" }